import { createAnalyticsSchema } from './../factory/createAnalyticsSchema';
import z from 'zod';
export var PatientInformationSchema = createAnalyticsSchema({
    data: z.any(),
});
